module.exports = __webpack_public_path__ + "assets/img/arrow_left.741328ac.svg";